import { Component, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ModalComponent, SnackbarComponent, SpinnerComponent, TagIconComponent } from '@tecalisdev/infinity';
import { ModalConfirmationService } from './shared/services/modal-confirmation.service';
import { NgIf } from '@angular/common';
import { SnackbarService } from './shared/services/snackbar.service';
import { LoadingService } from './shared/services/loading.service';
import { filter } from 'rxjs';
import { MasterService } from './shared/services/master.service';
import { ToolbarHelperService } from './shared/services/toolbar-helper.service';

@Component({
	selector: 'app-root',
	imports: [RouterOutlet, ModalComponent, TagIconComponent, NgIf, SnackbarComponent, SpinnerComponent],
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss',
})
export class AppComponent {
	modalConfirmationService = inject(ModalConfirmationService);
	snackbarService = inject(SnackbarService);
	loading = inject(LoadingService);
	router = inject(Router);
	masterService = inject(MasterService);
	toolbarHelperService = inject(ToolbarHelperService);

	private currentUrl: string = '';

	constructor() {
		this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
			const previousUrl = this.currentUrl;
			this.currentUrl = event.url;
			this.toolbarHelperService.setPreviousUrl(previousUrl);
		});
	}
}
